import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'StatusBanner';
const surveyName = 'HotelRecommendationNeeded';

const telemetry = createTelemetryObject({
  actions: {
    trackError: (error: Error | unknown) => ({
      category,
      action: 'updateInviteePropertyNeedHotelRecommendations',
      actionType: 'error',
      extraInfo: { error },
    }),
    answerClicked: (answerValue: string) => ({
      category,
      action: 'TravelButtonInteracted',
      label: `${surveyName}CTA`,
      extraInfo: {
        surveyName,
        answerValue,
      },
    }),
    pageViewed: () => ({
      category,
      action: 'PageViewed',
      page: 'accommodationsPage',
      extraInfo: {
        surveyName,
        name: 'guest.wedding.accommodations',
      },
    }),
  },
});

export const { useTelemetry: useStatusBannerTelemetry, TelemetryProvider: StatusBannerTelemetryProvider } = createTelemetry(telemetry);
